import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import PrivilegesLayer from "../components/PrivilegesLayer";

const PrivilegesPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout pageTitle="Role Privileges">

        {/* BlankPageLayer */}
        <PrivilegesLayer />
      </MasterLayout>
    </>
  );
};

export default PrivilegesPage;
